import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateTimeManagementDto } from "@myapp/contract";
import { timeEntryApi } from "../service";
import { timeEntryKeys } from "../time-entry.keys";
import { rescheduleKeys } from "src/entities/reschedule";
import { appointmentKeys } from "src/entities/appointment/api/appointment.keys";

export function useUpdateTimeManagement() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, dto }: { id: number; dto: UpdateTimeManagementDto }) =>
      timeEntryApi.updateTimeManagement(id, dto).then((r) => r.data),
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: timeEntryKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: timeEntryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: rescheduleKeys.count() });
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
    },
  });
}
